import * as entity from '@common/domain/entities/RoleProjectJobNumber'
import * as app from '@framework/app';
import { IColumnOptions, IDataEndPoint } from '../../../framework/interfaces/IEntity';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { FieldType } from '../../../framework/core/Enums';
export class RoleProjectJobNumberEndPoints extends entity.RoleProjectJobNumberEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
     return app.config.controllerRouteRoot + "/role/projectJobNumbers/" + serviceCommand.context.entityId 
    }
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/addProjectNumber",
    //url: app.config.controllerRouteRoot + "/user/addRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        projectJobNumberId: serviceCommand.data.id,
        roleId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.organisationId
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/removeProjectNumber",
    //url: app.config.controllerRouteRoot + "/user/removeRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        projectJobNumberId: serviceCommand.data.id,
        roleId: serviceCommand.context.entityId,
        organisationId: serviceCommand.data.organisationId
      }
    },
    method: "POST"
  };
  search?: IDataEndPoint = null;
}


export class RoleProjectJobNumberPerUserEndPoints extends entity.RoleProjectJobNumberEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/projectJobNumbers/" + serviceCommand.context.entityId
    }
  };
  
  search?: IDataEndPoint = null;
}

export class RoleProjectJobNumberFormFields extends entity.RoleProjectJobNumberFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class RoleProjectJobNumberForm extends entity.RoleProjectJobNumberForm {
  protected roleProjectJobNumberFormEndPoints: RoleProjectJobNumberEndPoints = new RoleProjectJobNumberEndPoints();
  protected roleProjectJobNumberFormFields: RoleProjectJobNumberFormFields = new RoleProjectJobNumberFormFields();
}

export class RoleProjectJobNumberListColumns extends entity.RoleProjectJobNumberListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      var selected: IColumnOptions = { field: "selected", width: "140px", fieldType: FieldType.Byte };
      var name: IColumnOptions = { field: "sysproJobNo", fieldType: FieldType.String, name: "Name" };
      selected.readOnly = false;
      selected.endPoints = new RoleProjectJobNumberEndPoints();
      this.push(selected);
      this.push(name);
    } catch  { }
  }
}

export class RoleProjectJobNumberPerUserListColumns extends entity.RoleProjectJobNumberListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      var name: IColumnOptions = { field: "sysproJobNo", fieldType: FieldType.String, name: "Name" };
      this.push(name);
    } catch  { }
  }
}

export class RoleProjectJobNumberList extends entity.RoleProjectJobNumberList {
  protected roleProjectJobNumberListEndPoints: RoleProjectJobNumberEndPoints = new RoleProjectJobNumberEndPoints();
  protected roleProjectJobNumberListColumns: RoleProjectJobNumberListColumns = new RoleProjectJobNumberListColumns();
  public disableNavigation: boolean = true;
}

export class RoleProjectJobNumberPerUserList extends entity.RoleProjectJobNumberList {
  protected roleProjectJobNumberListEndPoints: RoleProjectJobNumberPerUserEndPoints = new RoleProjectJobNumberPerUserEndPoints();
  protected roleProjectJobNumberListColumns: RoleProjectJobNumberPerUserListColumns = new RoleProjectJobNumberPerUserListColumns();
  public disableNavigation: boolean = true;
}
